import { useState, useEffect } from "react";
//import Grid from "@mui/material/Grid2";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import ProcesosApi from "api/procesosApi";

function CardAsesor() {
  const [totales, setTotales] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDatosAsesor = async () => {
      try {
        const respAsesor = await ProcesosApi.obtenerEstadisticas("ASESOR");
        const data = respAsesor.data[0];
        setTotales(data);
        setLoading(false);
      } catch (error) {
        console.error("Error al obtener los datos del backend:", error);
        setLoading(false);
      }
    };
    fetchDatosAsesor();
  }, []);

  // Función para obtener color según el estado
  const getEstadoColor = (estado) => {
    switch (estado) {
      case "BORRADOR":
        return "#9e9e9e";
      case "PENDIENTE":
        return "#ff9800";
      case "EN PROCESO":
        return "#2196f3";
      case "EN CURSO":
        return "#4caf50";
      case "EXITOSO":
        return "#4caf50";
      case "FALLIDO":
        return "#f44336";
      case "RECHAZADO":
        return "#f44336";
      default:
        return "#9e9e9e";
    }
  };

  if (loading) {
    return (
      <Card>
        <SuiBox p={3} textAlign="center">
          <SuiTypography variant="body2" textColor="text">
            Cargando estadísticas...
          </SuiTypography>
        </SuiBox>
      </Card>
    );
  }

  return (
    <div style={{ width: "100%" }}>
      <style>
        {`
          .stats-card {
            transition: transform 0.2s, box-shadow 0.2s;
          }
          .stats-card:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 20px rgba(0,0,0,0.1);
          }
          .recent-processes {
            max-height: 300px;
            overflow-y: auto;
          }
          .recent-processes::-webkit-scrollbar {
            width: 4px;
          }
          .recent-processes::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 10px;
          }
          .recent-processes::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 10px;
          }
        `}
      </style>

      <Card>
        {/* Header */}
        <SuiBox display="flex" justifyContent="space-between" alignItems="center" p={2}>
          <SuiBox>
            <SuiTypography variant="h6" gutterBottom>
              Panel del Asesor
            </SuiTypography>
          </SuiBox>
          <SuiBox>
            <SuiBox display="flex" alignItems="center" lineHeight={0}>
              <Icon className="font-bold text-info">person</Icon>
              <SuiTypography variant="button" fontWeight="regular" textColor="text">
                &nbsp;
                <strong>
                  {totales.cantProcesos === 0
                    ? "Sin procesos"
                    : totales.cantProcesos === 1
                    ? "1 proceso creado"
                    : `${totales.cantProcesos} procesos creados`}
                </strong>
              </SuiTypography>
            </SuiBox>
          </SuiBox>
          <SuiBox>
            <Icon
              style={{ color: "#2196f3", cursor: "pointer" }}
              onClick={() => window.location.reload()}
              title="Actualizar"
            >
              refresh
            </Icon>
          </SuiBox>
        </SuiBox>

        {/* Estadísticas Principales */}
        <SuiBox p={2}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(6, 1fr)",
              gap: "16px",
              width: "100%",
            }}
          >
            {/* Borrador */}
            <Card className="stats-card" style={{ backgroundColor: "#f5f5f5" }}>
              <SuiBox p={2} textAlign="center">
                <Icon style={{ fontSize: "40px", color: "#9e9e9e", marginBottom: "8px" }}>
                  edit
                </Icon>
                <SuiTypography variant="h4" fontWeight="bold" textColor="dark">
                  {totales.cantBorrador}
                </SuiTypography>
                <SuiTypography variant="button" textColor="text" fontWeight="medium">
                  En Borrador
                </SuiTypography>
              </SuiBox>
            </Card>

            {/* Pendientes */}
            <Card className="stats-card" style={{ backgroundColor: "#fff3e0" }}>
              <SuiBox p={2} textAlign="center">
                <Icon style={{ fontSize: "40px", color: "#ff9800", marginBottom: "8px" }}>
                  schedule
                </Icon>
                <SuiTypography variant="h4" fontWeight="bold" textColor="dark">
                  {totales.cantPendiente}
                </SuiTypography>
                <SuiTypography variant="button" textColor="text" fontWeight="medium">
                  Pendientes
                </SuiTypography>
              </SuiBox>
            </Card>

            {/* En Proceso */}
            <Card className="stats-card" style={{ backgroundColor: "#e3f2fd" }}>
              <SuiBox p={2} textAlign="center">
                <Icon style={{ fontSize: "40px", color: "#2196f3", marginBottom: "8px" }}>
                  autorenew
                </Icon>
                <SuiTypography variant="h4" fontWeight="bold" textColor="dark">
                  {totales.cantEnProceso}
                </SuiTypography>
                <SuiTypography variant="button" textColor="text" fontWeight="medium">
                  En Proceso
                </SuiTypography>
              </SuiBox>
            </Card>

            {/* Exitosos */}
            <Card className="stats-card" style={{ backgroundColor: "#e8f5e8" }}>
              <SuiBox p={2} textAlign="center">
                <Icon style={{ fontSize: "40px", color: "#4caf50", marginBottom: "8px" }}>
                  check_circle
                </Icon>
                <SuiTypography variant="h4" fontWeight="bold" textColor="dark">
                  {totales.cantExitosos}
                </SuiTypography>
                <SuiTypography variant="button" textColor="text" fontWeight="medium">
                  Exitosos
                </SuiTypography>
              </SuiBox>
            </Card>

            {/* Fallidos */}
            <Card className="stats-card" style={{ backgroundColor: "#ffebee" }}>
              <SuiBox p={2} textAlign="center">
                <Icon style={{ fontSize: "40px", color: "#f44336", marginBottom: "8px" }}>
                  cancel
                </Icon>
                <SuiTypography variant="h4" fontWeight="bold" textColor="dark">
                  {totales.cantFallidos}
                </SuiTypography>
                <SuiTypography variant="button" textColor="text" fontWeight="medium">
                  Fallidos
                </SuiTypography>
              </SuiBox>
            </Card>

            {/* Validados */}
            <Card className="stats-card" style={{ backgroundColor: "#f3e5f5" }}>
              <SuiBox p={2} textAlign="center">
                <Icon style={{ fontSize: "40px", color: "#9c27b0", marginBottom: "8px" }}>
                  verified
                </Icon>
                <SuiTypography variant="h4" fontWeight="bold" textColor="dark">
                  {totales.cantValidados}
                </SuiTypography>
                <SuiTypography variant="button" textColor="text" fontWeight="medium">
                  Validados
                </SuiTypography>
              </SuiBox>
            </Card>
          </div>
        </SuiBox>

        {/* Procesos Recientes */}
        <SuiBox p={2}>
          <SuiTypography variant="h6" fontWeight="bold" textColor="dark" mb={2}>
            Procesos Recientes
            {totales.cantidadRecientes > 0 && (
              <Chip
                label={`${totales.cantidadRecientes} últimos 7 días`}
                size="small"
                style={{
                  marginLeft: "8px",
                  backgroundColor: "#e3f2fd",
                  color: "#1976d2",
                }}
              />
            )}
          </SuiTypography>

          {totales.procesosRecientes && totales.procesosRecientes.length > 0 ? (
            <div className="recent-processes">
              {totales.procesosRecientes.map((proceso, index) => (
                <Card
                  key={index}
                  style={{
                    marginBottom: "8px",
                    padding: "12px",
                    border: "1px solid #e0e0e0",
                  }}
                >
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <SuiBox>
                      <SuiTypography variant="button" fontWeight="bold" textColor="dark">
                        {proceso.identificador}
                      </SuiTypography>
                      <SuiTypography variant="caption" textColor="text" display="block">
                        {proceso.cliente}
                      </SuiTypography>
                      <SuiTypography variant="caption" textColor="secondary" display="block">
                        Creado: {proceso.fecha_creacion}
                      </SuiTypography>
                    </SuiBox>
                    <SuiBox display="flex" alignItems="center" gap={1}>
                      <Chip
                        label={proceso.estado}
                        size="small"
                        style={{
                          backgroundColor: getEstadoColor(proceso.estado),
                          color: "white",
                          fontWeight: "bold",
                          fontSize: "10px",
                        }}
                      />
                      {proceso.validado && (
                        <Icon style={{ color: "#4caf50", fontSize: "16px" }} title="Validado">
                          verified
                        </Icon>
                      )}
                      {proceso.admitido && (
                        <Icon style={{ color: "#2196f3", fontSize: "16px" }} title="Admitido">
                          check_circle
                        </Icon>
                      )}
                    </SuiBox>
                  </Box>
                </Card>
              ))}
            </div>
          ) : (
            <SuiBox textAlign="center" py={3}>
              <Icon style={{ fontSize: "48px", color: "#e0e0e0", marginBottom: "16px" }}>
                inbox
              </Icon>
              <SuiTypography variant="body2" textColor="text">
                No hay procesos recientes
              </SuiTypography>
            </SuiBox>
          )}
        </SuiBox>
      </Card>
    </div>
  );
}

export default CardAsesor;
